// Inventory Outlets Mutations

export const updateOutletsList = (state, payload) => {
  state.outletsList = payload
}

export const fetchOutletInfo = (state, payload) => {
  state.outletInfo = payload
}

export const setFullOutletsList = (state, payload) => {
  state.fullOutletsList = payload
}
